/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BookingStock } from '../model';
// @ts-ignore
import { BookingStockAddRange } from '../model';
// @ts-ignore
import { BookingStockSearchResult } from '../model';
// @ts-ignore
import { ValidationError } from '../model';
/**
 * OrganisationBookingStockApi - axios parameter creator
 * @export
 */
export const OrganisationBookingStockApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  Adds an empty week/month value for the Product for the first active main and sub category found.  It returns the Stock data from the start to the end of that week/month the same as calling the GET:/stock endpoint. 
         * @summary Add empty week/month value for Product
         * @param {string} buyerOrgId 
         * @param {BookingStockAddRange} bookingStockAddRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockAddWeekCreate: async (buyerOrgId: string, bookingStockAddRange: BookingStockAddRange, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingStockAddWeekCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingStockAddRange' is not null or undefined
            assertParamExists('orgBookingStockAddWeekCreate', 'bookingStockAddRange', bookingStockAddRange)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/stock/add-week`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingStockAddRange, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates or Updates Stock data for the Product and categories
         * @param {string} buyerOrgId 
         * @param {BookingStock} bookingStock 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockCreate: async (buyerOrgId: string, bookingStock: BookingStock, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingStockCreate', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'bookingStock' is not null or undefined
            assertParamExists('orgBookingStockCreate', 'bookingStock', bookingStock)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/stock`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bookingStock, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a day by day tally of required, average prices, and kill values for the given date     ranges.  # Date range  If org.setting_stockbook_monthly is set to True then the date range used will be from the first day of the month to the     last day of the month.  If set to False then the date range used will be from the first day of the week (Sunday) to the last (Saturday).  These ranges will be used in calculating the `date_from` and `date_to` below.  # dates  By default if no date_from and date_to values are passed through the range returned is calculated by the following conditions:  `date_from`  If passed through then it will set the start date to first day of the time range.  If NOT passed through it will default to the first day of the time range of the current date.  `date_to`  If passed through it will set the end date to the last day of the time range.  If NOT passed through it defaults to the last day of of the time range of the current date.  However, if there is data present in either the Stock table or a Booking for the given Product in a date after the     10 weeks | 3 months then it will set the end     date to the last day of that time range that the Booking/Stock is within.  # Returned data  Along with the base keys `group`, `date`, `incoming_total`, `avg_price_total`, and `kill_total` the following fields     are dynamically generated based on the Main and Sub categories setup on the Org for the Product.  As an example, if there were the following Main Categories with their Sub Categories:  `dog` - `labrador` - `mixed`  `cat` - `bengal` - `mixed`  Then a key would be generated for each to be unique under the `incoming`, `avg_price`, and `kill` sections where by     the key generated is in the following format: `incoming_m_<main category key>_s_<sub category_key>`  ``` [     {         \"group\": \"1 Jan - 7 Jan\",         \"date\": \"2024-01-01\",         \"incoming_m_dog_s_labrador\": 1,         \"incoming_m_dog_s_mixed\": 2,         \"incoming_m_cat_s_bengal\": 4,         \"incoming_m_cat_s_mixed\": 16,         \"incoming_total\": 23,          ... avg_price_m_<main category key>_s_<sub category key>         \"avg_price_m_dog_s_labrador\": 32,         ...         \"avg_price_total\": 64,          ... kill_m_<main category key>_s_<sub category key>         \"kill_m_dog_s_labrador\": 128,         ...         \"kill_total\": 256,     },     ... ] ```          
         * @summary Return Stock data for the Product
         * @param {string} buyerOrgId 
         * @param {string} product Product
         * @param {string} [dateFrom] Date from
         * @param {string} [dateTo] Date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockList: async (buyerOrgId: string, product: string, dateFrom?: string, dateTo?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingStockList', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('orgBookingStockList', 'product', product)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/stock`
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (dateFrom !== undefined) {
                localVarQueryParameter['date_from'] = (dateFrom as any instanceof Date) ?
                    (dateFrom as any).toISOString().substr(0,10) :
                    dateFrom;
            }

            if (dateTo !== undefined) {
                localVarQueryParameter['date_to'] = (dateTo as any instanceof Date) ?
                    (dateTo as any).toISOString().substr(0,10) :
                    dateTo;
            }

            if (product !== undefined) {
                localVarQueryParameter['product'] = product;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingStockApi - functional programming interface
 * @export
 */
export const OrganisationBookingStockApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingStockApiAxiosParamCreator(configuration)
    return {
        /**
         *  Adds an empty week/month value for the Product for the first active main and sub category found.  It returns the Stock data from the start to the end of that week/month the same as calling the GET:/stock endpoint. 
         * @summary Add empty week/month value for Product
         * @param {string} buyerOrgId 
         * @param {BookingStockAddRange} bookingStockAddRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingStockAddWeekCreate(buyerOrgId: string, bookingStockAddRange: BookingStockAddRange, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingStockSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingStockAddWeekCreate(buyerOrgId, bookingStockAddRange, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Creates or Updates Stock data for the Product and categories
         * @param {string} buyerOrgId 
         * @param {BookingStock} bookingStock 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingStockCreate(buyerOrgId: string, bookingStock: BookingStock, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingStock>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingStockCreate(buyerOrgId, bookingStock, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns a day by day tally of required, average prices, and kill values for the given date     ranges.  # Date range  If org.setting_stockbook_monthly is set to True then the date range used will be from the first day of the month to the     last day of the month.  If set to False then the date range used will be from the first day of the week (Sunday) to the last (Saturday).  These ranges will be used in calculating the `date_from` and `date_to` below.  # dates  By default if no date_from and date_to values are passed through the range returned is calculated by the following conditions:  `date_from`  If passed through then it will set the start date to first day of the time range.  If NOT passed through it will default to the first day of the time range of the current date.  `date_to`  If passed through it will set the end date to the last day of the time range.  If NOT passed through it defaults to the last day of of the time range of the current date.  However, if there is data present in either the Stock table or a Booking for the given Product in a date after the     10 weeks | 3 months then it will set the end     date to the last day of that time range that the Booking/Stock is within.  # Returned data  Along with the base keys `group`, `date`, `incoming_total`, `avg_price_total`, and `kill_total` the following fields     are dynamically generated based on the Main and Sub categories setup on the Org for the Product.  As an example, if there were the following Main Categories with their Sub Categories:  `dog` - `labrador` - `mixed`  `cat` - `bengal` - `mixed`  Then a key would be generated for each to be unique under the `incoming`, `avg_price`, and `kill` sections where by     the key generated is in the following format: `incoming_m_<main category key>_s_<sub category_key>`  ``` [     {         \"group\": \"1 Jan - 7 Jan\",         \"date\": \"2024-01-01\",         \"incoming_m_dog_s_labrador\": 1,         \"incoming_m_dog_s_mixed\": 2,         \"incoming_m_cat_s_bengal\": 4,         \"incoming_m_cat_s_mixed\": 16,         \"incoming_total\": 23,          ... avg_price_m_<main category key>_s_<sub category key>         \"avg_price_m_dog_s_labrador\": 32,         ...         \"avg_price_total\": 64,          ... kill_m_<main category key>_s_<sub category key>         \"kill_m_dog_s_labrador\": 128,         ...         \"kill_total\": 256,     },     ... ] ```          
         * @summary Return Stock data for the Product
         * @param {string} buyerOrgId 
         * @param {string} product Product
         * @param {string} [dateFrom] Date from
         * @param {string} [dateTo] Date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingStockList(buyerOrgId: string, product: string, dateFrom?: string, dateTo?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BookingStockSearchResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingStockList(buyerOrgId, product, dateFrom, dateTo, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingStockApi - factory interface
 * @export
 */
export const OrganisationBookingStockApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingStockApiFp(configuration)
    return {
        /**
         *  Adds an empty week/month value for the Product for the first active main and sub category found.  It returns the Stock data from the start to the end of that week/month the same as calling the GET:/stock endpoint. 
         * @summary Add empty week/month value for Product
         * @param {string} buyerOrgId 
         * @param {BookingStockAddRange} bookingStockAddRange 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockAddWeekCreate(buyerOrgId: string, bookingStockAddRange: BookingStockAddRange, options?: any): AxiosPromise<Array<BookingStockSearchResult>> {
            return localVarFp.orgBookingStockAddWeekCreate(buyerOrgId, bookingStockAddRange, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates or Updates Stock data for the Product and categories
         * @param {string} buyerOrgId 
         * @param {BookingStock} bookingStock 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockCreate(buyerOrgId: string, bookingStock: BookingStock, options?: any): AxiosPromise<BookingStock> {
            return localVarFp.orgBookingStockCreate(buyerOrgId, bookingStock, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a day by day tally of required, average prices, and kill values for the given date     ranges.  # Date range  If org.setting_stockbook_monthly is set to True then the date range used will be from the first day of the month to the     last day of the month.  If set to False then the date range used will be from the first day of the week (Sunday) to the last (Saturday).  These ranges will be used in calculating the `date_from` and `date_to` below.  # dates  By default if no date_from and date_to values are passed through the range returned is calculated by the following conditions:  `date_from`  If passed through then it will set the start date to first day of the time range.  If NOT passed through it will default to the first day of the time range of the current date.  `date_to`  If passed through it will set the end date to the last day of the time range.  If NOT passed through it defaults to the last day of of the time range of the current date.  However, if there is data present in either the Stock table or a Booking for the given Product in a date after the     10 weeks | 3 months then it will set the end     date to the last day of that time range that the Booking/Stock is within.  # Returned data  Along with the base keys `group`, `date`, `incoming_total`, `avg_price_total`, and `kill_total` the following fields     are dynamically generated based on the Main and Sub categories setup on the Org for the Product.  As an example, if there were the following Main Categories with their Sub Categories:  `dog` - `labrador` - `mixed`  `cat` - `bengal` - `mixed`  Then a key would be generated for each to be unique under the `incoming`, `avg_price`, and `kill` sections where by     the key generated is in the following format: `incoming_m_<main category key>_s_<sub category_key>`  ``` [     {         \"group\": \"1 Jan - 7 Jan\",         \"date\": \"2024-01-01\",         \"incoming_m_dog_s_labrador\": 1,         \"incoming_m_dog_s_mixed\": 2,         \"incoming_m_cat_s_bengal\": 4,         \"incoming_m_cat_s_mixed\": 16,         \"incoming_total\": 23,          ... avg_price_m_<main category key>_s_<sub category key>         \"avg_price_m_dog_s_labrador\": 32,         ...         \"avg_price_total\": 64,          ... kill_m_<main category key>_s_<sub category key>         \"kill_m_dog_s_labrador\": 128,         ...         \"kill_total\": 256,     },     ... ] ```          
         * @summary Return Stock data for the Product
         * @param {string} buyerOrgId 
         * @param {string} product Product
         * @param {string} [dateFrom] Date from
         * @param {string} [dateTo] Date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingStockList(buyerOrgId: string, product: string, dateFrom?: string, dateTo?: string, options?: any): AxiosPromise<Array<BookingStockSearchResult>> {
            return localVarFp.orgBookingStockList(buyerOrgId, product, dateFrom, dateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingStockAddWeekCreate operation in OrganisationBookingStockApi.
 * @export
 * @interface OrganisationBookingStockApiOrgBookingStockAddWeekCreateRequest
 */
export interface OrganisationBookingStockApiOrgBookingStockAddWeekCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockAddWeekCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingStockAddRange}
     * @memberof OrganisationBookingStockApiOrgBookingStockAddWeekCreate
     */
    readonly bookingStockAddRange: BookingStockAddRange
}

/**
 * Request parameters for orgBookingStockCreate operation in OrganisationBookingStockApi.
 * @export
 * @interface OrganisationBookingStockApiOrgBookingStockCreateRequest
 */
export interface OrganisationBookingStockApiOrgBookingStockCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockCreate
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {BookingStock}
     * @memberof OrganisationBookingStockApiOrgBookingStockCreate
     */
    readonly bookingStock: BookingStock
}

/**
 * Request parameters for orgBookingStockList operation in OrganisationBookingStockApi.
 * @export
 * @interface OrganisationBookingStockApiOrgBookingStockListRequest
 */
export interface OrganisationBookingStockApiOrgBookingStockListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockList
     */
    readonly buyerOrgId: string

    /**
     * Product
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockList
     */
    readonly product: string

    /**
     * Date from
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockList
     */
    readonly dateFrom?: string

    /**
     * Date to
     * @type {string}
     * @memberof OrganisationBookingStockApiOrgBookingStockList
     */
    readonly dateTo?: string
}

/**
 * OrganisationBookingStockApi - object-oriented interface
 * @export
 * @class OrganisationBookingStockApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingStockApi extends BaseAPI {
    /**
     *  Adds an empty week/month value for the Product for the first active main and sub category found.  It returns the Stock data from the start to the end of that week/month the same as calling the GET:/stock endpoint. 
     * @summary Add empty week/month value for Product
     * @param {OrganisationBookingStockApiOrgBookingStockAddWeekCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingStockApi
     */
    public orgBookingStockAddWeekCreate(requestParameters: OrganisationBookingStockApiOrgBookingStockAddWeekCreateRequest, options?: any) {
        return OrganisationBookingStockApiFp(this.configuration).orgBookingStockAddWeekCreate(requestParameters.buyerOrgId, requestParameters.bookingStockAddRange, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates or Updates Stock data for the Product and categories
     * @param {OrganisationBookingStockApiOrgBookingStockCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingStockApi
     */
    public orgBookingStockCreate(requestParameters: OrganisationBookingStockApiOrgBookingStockCreateRequest, options?: any) {
        return OrganisationBookingStockApiFp(this.configuration).orgBookingStockCreate(requestParameters.buyerOrgId, requestParameters.bookingStock, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a day by day tally of required, average prices, and kill values for the given date     ranges.  # Date range  If org.setting_stockbook_monthly is set to True then the date range used will be from the first day of the month to the     last day of the month.  If set to False then the date range used will be from the first day of the week (Sunday) to the last (Saturday).  These ranges will be used in calculating the `date_from` and `date_to` below.  # dates  By default if no date_from and date_to values are passed through the range returned is calculated by the following conditions:  `date_from`  If passed through then it will set the start date to first day of the time range.  If NOT passed through it will default to the first day of the time range of the current date.  `date_to`  If passed through it will set the end date to the last day of the time range.  If NOT passed through it defaults to the last day of of the time range of the current date.  However, if there is data present in either the Stock table or a Booking for the given Product in a date after the     10 weeks | 3 months then it will set the end     date to the last day of that time range that the Booking/Stock is within.  # Returned data  Along with the base keys `group`, `date`, `incoming_total`, `avg_price_total`, and `kill_total` the following fields     are dynamically generated based on the Main and Sub categories setup on the Org for the Product.  As an example, if there were the following Main Categories with their Sub Categories:  `dog` - `labrador` - `mixed`  `cat` - `bengal` - `mixed`  Then a key would be generated for each to be unique under the `incoming`, `avg_price`, and `kill` sections where by     the key generated is in the following format: `incoming_m_<main category key>_s_<sub category_key>`  ``` [     {         \"group\": \"1 Jan - 7 Jan\",         \"date\": \"2024-01-01\",         \"incoming_m_dog_s_labrador\": 1,         \"incoming_m_dog_s_mixed\": 2,         \"incoming_m_cat_s_bengal\": 4,         \"incoming_m_cat_s_mixed\": 16,         \"incoming_total\": 23,          ... avg_price_m_<main category key>_s_<sub category key>         \"avg_price_m_dog_s_labrador\": 32,         ...         \"avg_price_total\": 64,          ... kill_m_<main category key>_s_<sub category key>         \"kill_m_dog_s_labrador\": 128,         ...         \"kill_total\": 256,     },     ... ] ```          
     * @summary Return Stock data for the Product
     * @param {OrganisationBookingStockApiOrgBookingStockListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingStockApi
     */
    public orgBookingStockList(requestParameters: OrganisationBookingStockApiOrgBookingStockListRequest, options?: any) {
        return OrganisationBookingStockApiFp(this.configuration).orgBookingStockList(requestParameters.buyerOrgId, requestParameters.product, requestParameters.dateFrom, requestParameters.dateTo, options).then((request) => request(this.axios, this.basePath));
    }
}
